import { useNavigate, Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { logout } from '../services/AuthService';
import './console-navbar.css';
import logo from '../assets/img/AccessEVAEnterprise.jpg';
import logo_accesseva from '../assets/img/AccessEVA.jpg';
import { NavLink } from 'react-router-dom';
import './navbar.css';

function ConsoleNavbar({ onFeedbackShow }) {
  const auth = useAuth();
  const user = auth.getSession();
  const org = localStorage.getItem('org') || "";

  // Define base menu items that are always present
  const temp = (org === "") ? "" : '';
  const BASE_ITEMS = [
    { path: '/admin/Users', title: 'User' },
    /*  { path: '/admin/Projects', title: 'Corp Projects' }, */
    { path: '/admin/resources', title: `${temp} Resources` },
    { path: '/admin/QuestionSets', title: `${temp} Query Sets` }
  ];

  const DEPARTMENT_ITEM = { path: '/admin/departments', title: 'Department' };
  const items_admin = org ? [...BASE_ITEMS.slice(0, 1), DEPARTMENT_ITEM, ...BASE_ITEMS.slice(1)] : BASE_ITEMS;
  const navigate = useNavigate();
  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
    navigate('/');
  };

  const handleFeedbackShow = (e) => {
    e.preventDefault();
    onFeedbackShow();
  };

  const items_user = [
    { path: '/console/Projects', title: 'Projects' },
    { path: '/console/resources', title: 'Resources' },
  ];

  return (
    <div className='sticky-top'>
      <nav className="navbar navbar-expand-md bg-body-secondary py-0 px-2">
        <div className="container-fluid">
          <Link
            to="/console"
            className="navbar-brand fs-6 fw-bold text-muted"
          >
            Admin{ org && (`: ${org}`)} 
          </Link>
          <div className="collapse navbar-collapse justify-content-end" id="navbarAdmin">
            <button className="navbar-toggler collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#sidebarMenu"
              aria-controls="sidebarMenu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
          </div>
          
        </div>
      </nav>

      <nav className="navbar navbar-expand-md navbar-light bg-white py-0 border-bottom">
        <div className="container-fluid d-flex flex-grow-1">
          <Link to="/" className="navbar-brand fw-bold p-0 my-0">
            {org ? (
              logo && (
                <img
                  src={logo}
                  alt="Organization Logo"
                  style={{ height: "46px" }}
                  className="img-fluid px-0 my-0"
                />
              )
            ) : (
              logo_accesseva && (
                <img
                  src={logo_accesseva}
                  alt="AccessEva Logo"
                  style={{ height: "46px" }}
                  className="img-fluid px-0 my-0"
                />
              )
            )}
          </Link>
          <button className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

         
          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ms-auto mb-2 mb-md-0 flex-nowrap">
              {
                items_admin.map((item, i) => (
                  <li key={i} className="nav-item">
                    <NavLink className="nav-link text-nowrap" to={item.path}>{item.title}</NavLink>
                  </li>
                ))
              }

              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle link-primary" data-bs-toggle="dropdown" onClick={(e) => e.preventDefault()} aria-expanded="false">{user.firstname} {user.lastname}(admin)</button>
                <ul className="dropdown-menu dropdown-menu-end">

                  <li>
                    <NavLink className="dropdown-item" to='/admin/profile'>Account</NavLink>
                  </li>
                  {org !== "" && (
                    <>
                      <li>
                        <NavLink className="dropdown-item" to='/admin/Orgnization'>Organization</NavLink>
                      </li>
                    </>
                  )}
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to='/console/Projects'>User Dashboard</NavLink>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li><button className="dropdown-item" onClick={handleLogout}>Log Out</button></li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default ConsoleNavbar;
